import type { FetchQueryOptions } from '@zenos/front-end-util-types';
import { getEmployeeDetails } from '../api/employee.api';

export const getEmployeeDetailsQuery = (userId?: number) =>
  ({
    queryFn: () => getEmployeeDetails(userId),
    queryKey: ['employeeDetails', userId],
  }) satisfies FetchQueryOptions<typeof getEmployeeDetails>;
